// extracted by mini-css-extract-plugin
export default {"container":"RoofClaimingContractWarranty_container__KPO4P"};